"use client";

// src/components/link-list/link-list.tsx
import { tv } from "tailwind-variants";
import { Link } from "../link/link.mjs";
import { jsx } from "react/jsx-runtime";
var linkList = tv({
  slots: {
    listContainer: "sm:flex justify-center text-center",
    listDivider: "sm:divide-x divide-text-disabled-secondary sm:flex-row flex-col flex",
    listItem: "text-text-neutral-tertiary pl-2 pr-2 hover:no-underline hover:text-black text-sm",
    listItemInner: "leading-loose sm:leading-none inline-block"
  },
  variants: {
    isVertical: {
      true: {
        listContainer: "flex text-left justify-start",
        listDivider: "divide-transparent grid grid-cols-1 grid-cols-2 md:grid-cols-1 gap-4 w-full",
        listItem: "px-0"
      }
    }
  }
});
var style = linkList();
var LinkListItem = ({
  item: { url, title },
  as = "a",
  isVertical = false,
  track
}) => /* @__PURE__ */ jsx(
  Link,
  {
    className: style.listItem({ isVertical }),
    href: url,
    as,
    track,
    children: /* @__PURE__ */ jsx("span", { className: style.listItemInner(), children: title })
  }
);
var LinkList = ({
  items,
  label,
  nextLink,
  isVertical = false,
  track
}) => /* @__PURE__ */ jsx("div", { className: style.listContainer({ isVertical }), children: /* @__PURE__ */ jsx("nav", { className: style.listDivider({ isVertical }), "aria-label": label, children: items.map((item) => /* @__PURE__ */ jsx(
  LinkListItem,
  {
    item,
    as: item.isExternal || item.disableNextRouting ? "a" : nextLink || "a",
    isVertical,
    track: item.isExternal ? track : void 0
  },
  item.title
)) }) });
export {
  LinkList
};
